export const actionOptions = {
  "all": [
    {
      title: "Release Rule",
      cls: "bulk-release-rule",
      icon: "hourglass",
      disabled:false
    }
  ],
  "actions": [
    {
      title: "Release Rule",
      cls: "release-rule",
      icon: "hourglass",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/orderHoldRules/filter/actionOptions.js